import { render, staticRenderFns } from "./EditPreSurveyQuestion.vue?vue&type=template&id=4d188b94&scoped=true"
import script from "./EditPreSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./EditPreSurveyQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditPreSurveyQuestion.vue?vue&type=style&index=0&id=4d188b94&prod&lang=css"
import style1 from "./EditPreSurveyQuestion.vue?vue&type=style&index=1&id=4d188b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d188b94",
  null
  
)

export default component.exports